// import { CommonModal } from 'components'
// import React, { useState } from 'react'

// const PartymessageModal = (props) => {

//   const propsPartyMessageModal = {
//     ...props,
//   }

//   const [selectedParties, setSelectedParties] = useState([]);

//   const parties = [
//     { name: "Parle Biscuit Pvt Ltd", subtitle: "Send Message" },
//     { name: "Party Name 2", subtitle: "Select to Send Message" },
//     { name: "Party Name 3", subtitle: "Add Number to Send Message" },
//   ];

//   const handleCheckboxChange = (partyName) => {
//     setSelectedParties((prevSelected) => {
//       if (prevSelected.includes(partyName)) {
//         return prevSelected.filter((name) => name !== partyName);
//       } else {
//         return [...prevSelected, partyName];
//       }
//     });
//   };


//   return (
//     <>
//       <CommonModal {...propsPartyMessageModal}>
//         <div className="__suplierMsg_bxs">
//           <div className="party-container">
//             <p className="party-title">
//               Please select the party you want to notify via WhatsApp
//             </p>

//             <div className="__partyMain">
//               {parties.map((party, index) => (
//                 <label
//                   key={index}
//                   className={`party-card ${selectedParties.includes(party.name) ? "selected" : ""
//                     }`}
//                 >
//                   <div className="party-info">
//                     <span className="party-name">{party.name}</span>
//                     <span className="party-subtitle">{party.subtitle}</span>
//                   </div>
//                   <input
//                     type="checkbox"
//                     checked={selectedParties.includes(party.name)}
//                     onChange={() => handleCheckboxChange(party.name)}
//                   />
//                 </label>
//               ))}
//             </div>
//           </div>
//         </div>
//       </CommonModal>
//       <style>{`
//       /* Container */
// .party-container {
//   // max-width: 400px;
//   // margin: 20px auto;
//   font-family: "Arial", sans-serif;
// }

// /* Title */
// .party-title {
//   font-size: 14px;
//   color: #666;
//   margin-bottom: 12px;
// }

// .__partyMain {
//     display: flex;
//     flex-direction: column;
//     gap: 10px;
// }

// /* Party card */
// .party-card {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: #fff;
//   border: 1.5px solid #e0e0e0;
//   padding: 10px 18px;
//   // margin-bottom: 10px;
//   border-radius: 6px;
//   cursor: pointer;
//   transition: all 0.2s ease-in-out;
// }

// .party-card:hover {
//   border-color: #007bff;
// }

// /* Selected state */
// .party-card.selected {
//   border-color: #007bff;
//   background-color: #f5faff;
// }

// /* Party info */
// .party-info {
//   display: flex;
//   flex-direction: column;
// }

// /* Party name */
// .party-name {
//   font-size: 16px;
//   line-height: 16px;
//   font-weight: 600;
//   color: #000;
// }

// /* Subtitle text */
// .party-subtitle {
//   font-size: 13px;
//   color: #888;
//   margin-top: 2px;
// }

// /* Checkbox */
// .party-card input[type="checkbox"] {
//   width: 18px;
//   height: 18px;
//   accent-color: #007bff;
//   cursor: pointer;
//   display: block;
//   left: 0;
//   position: relative;
// }

//       `}</style>
//     </>
//   )
// }

// export default PartymessageModal


import React from "react";
import { CommonModal } from "components";

const PartymessageModal = (props) => {
  const {

    parties = [],
    title = "Please select the party you want to notify via WhatsApp",
    partyType = "", // Example: is_supplier | is_consignors | is_consignees
    automessageSelected,
    setAutomessageSelected,
  } = props;

  const handleCheckboxChange = (party) => {
    setAutomessageSelected((prev) => {
      const alreadyExists = prev[partyType].includes(party._id);

      const updated = alreadyExists
        ? prev[partyType].filter((id) => id !== party._id)
        : [...prev[partyType], party._id];

      return {
        ...prev,
        [partyType]: updated,
      };
    });
  };


  return (
    <>
      <CommonModal {...props}>
        <div className="__suplierMsg_bxs">
          <div className="party-container">
           { <p className="party-title">{`Please select the ${partyType == "is_consignors" ? "Party" : "Consignee"} you want to notify via WhatsApp`}</p>}

            <div className="__partyMain">
              {parties.length > 0 ? (
                parties.map((party, index) => (
                  <label
                    key={index}
                    className={`party-card ${automessageSelected[partyType]?.includes(party.name)
                      ? "selected"
                      : ""
                      }`}
                  >
                    <div className="party-info">
                      <span className="party-name">{party.name}</span>
                      <span className="party-subtitle">{party.mobile_no ? automessageSelected[partyType]?.some((item) => item === party._id) ? "Send Message" : "Select to Send Message" : "Add Number to Send Message"}</span>
                    </div>
                    <input
                      type="checkbox"
                      checked={automessageSelected[partyType]?.includes(party._id)}
                      onChange={() => handleCheckboxChange(party)}
                      disabled={!party.mobile_no}
                    />
                  </label>
                ))
              ) : (
                <p className="no-party">No {partyType == "is_consignors" ? "Party" : "Consignee"} available</p>
              )}
            </div>
          </div>
        </div>


      </CommonModal>
      <style>{`
      /* Container */
.party-container {
  // max-width: 400px;
  // margin: 20px auto;
  font-family: "Arial", sans-serif;
}

/* Title */
.party-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.__partyMain {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Party card */
.party-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border: 1.5px solid #e0e0e0;
  padding: 10px 18px;
  // margin-bottom: 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.party-card:hover {
  border-color: #007bff;
}

/* Selected state */
.party-card.selected {
  border-color: #007bff;
  background-color: #f5faff;
}

/* Party info */
.party-info {
  display: flex;
  flex-direction: column;
}

/* Party name */
.party-name {
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  color: #000;
}

/* Subtitle text */
.party-subtitle {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

/* Checkbox */
.party-card input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #007bff;
  cursor: pointer;
  display: block;
  left: 0;
  position: relative;
}

      `}</style>
    </>

  );
};

export default PartymessageModal;
